<template>
  <b-container fluid>
    <PortalNavbar show="true"></PortalNavbar>

    <div class="container">
      <section id="about-us-section">
        <div class="text-box">
          <h2>महामंडळाची स्थापना</h2>

          <p>महामंडळाची स्थापना दिनांक २५ सप्टेंबर, १९९८ च्या शासन निर्णयान्वये झाली असून, दिनांक २३.०४.१९९९ रोजी कंपनी कायदा, १९५६ अन्वये महामंडळाचे कामकाज सुरु झाले आहे. राज्यातील इतर मागासवर्गीयांच्या सर्वांगीण विकासासाठी तसेच ते करीत असलेल्या व्यवसायांना सक्षम करण्यासाठी अर्थसहाय्य करण्याचे कार्य या महामंडळाकडे सोपविले आहे.</p>
        </div>

        <div class="text-box">
          <h2>स्थापनेची उद्दिष्टे</h2>

          <ul>
            <li>
              <p>राज्यातील इतर मागासवर्गीयांच्या कल्याण व विकासासाठी कृषी विकास, पणन, संस्करण, कृषी उत्पादनाचा पुरवठा आणि साठवण, लघु उद्योग, इमारत बांधणी, परिवहन या कार्यक्रमांची आणि अन्य व्यवसाय (वैद्यकीय, अभियांत्रिकी, वास्तुशास्त्रीय यांसारखे) व्यापार किंवा उद्योग यांची योजना आखणे, त्यांना चालना देणे, सहाय्य करणे, सल्ला देणे, मदत करणे, वित्त पुरवठा करणे, त्यांचे संरक्षण करणे.</p>
            </li>
            <li>
              <p>इतर मागासवर्गीयांची आर्थिक स्थिती, उत्पादन निर्मिती, व्यवस्थापन आणि पणन यांचा विकास करणे / त्यात सुधारणा करणे, त्यांचे कामकाज, व्यवसाय, व्यापार किंवा उद्योग सुरु करण्यासाठी त्यांना भांडवल, पतसाधने, साधनसामुग्री आणि तांत्रिक व व्यवस्थापकीय साधने पुरविणे.</p>
            </li>
            <li>
              <p>इतर मागासवर्गीयांसाठी कृषी उत्पादने, वस्तु, साहित्य आणि सामुग्री यांची बनावट, निर्मिती, जुळवणी व पुरवठा यासाठी विविध क्षेत्रातील व्यक्ती किंवा संघटनांबरोबर करार करणे आणि त्यांच्याकडील मागण्या हाती घेणे आणि त्या इतर मागासवर्गीय लोकांना उपकंत्राटाने देऊन किंवा त्याबाबत त्यांच्याकडे कामाच्या मागण्या सुपूर्द करून, त्यांचेकडून कामे यथायोग्य रितीने पूर्ण करण्यासाठी आवश्यक वाटतील अशा सेवा देणे.</p>
            </li>
            <li>
              <p>राज्यातील इतर मागासवर्गीयांच्या कल्याणासाठी योजना सुरु करणे आणि त्यांना चालना देणे, या प्रयोजनासाठी अहवाल आणि निलप्रती (ब्लू प्रिंटस्) तयार करणे, तयार करुन घेणे आणि आकडेवारी व इतर माहिती गोळा करणे.</p>
            </li>
            <li>
              <p>वरील कामे प्रभावीपणे पार पाडण्यासाठी आवश्यक वाटेल त्याप्रमाणे कंपन्या, संघ, सल्लागार मंडळे किंवा योग्य त्या संस्था प्रवर्तित करणे आणि स्थापन करणे.</p>
            </li>
          </ul>
        </div>

        <div class="text-box">
          <h2>महामंडळाचे अधिकृत व वितरीत भाग भांडवल</h2>
          <p>महामंडळाचे अधिकृत भाग भांडवल रु. २५०.०० कोटी इतके असून, त्यापैकी मार्च, २०१५ पर्यंत शासनाकडून रु.१३४.९५ कोटी वितरीत करण्यात आले आहे.</p>
        </div>

        <div class="text-box">
            <h2>महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ</h2>
            <h3>(संचालक मंडळातील शासकीय सदस्यांची यादी)</h3>
            
            <table width="100%" border="1" cellspacing="0" cellpadding="0" class="about-table">
  <tbody><tr>
    <td >१.</td>
    <td >मा. सहसचिव </td>
    <td >कल्याण मंत्रालय, भारत सरकार, शास्त्री भवन, नवी दिल्ली.</td>
  </tr>
  <tr>
    <td>२.</td>
    <td>मा.व्यवस्थापकीय संचालक </td>
    <td>राष्ट्रीय मागासवर्ग वित्त व विकास महामंडळ, ५ वा मजला, एन.सी.यु. आय बिल्डींग, ३, सिरी  इन्स्टिट्यूशनल एरिया, ऑगस्ट क्रांती मार्ग, नवी दिल्ली- ११० ०१६.</td>
  </tr>
  <tr>
    <td>३.</td>
    <td>मा.प्रधान सचिव </td>
    <td>सामाजिक न्याय व विशेष सहाय्य विभाग, मंत्रालय, मुंबई- ४०० ०३२.</td>
  </tr>
  <tr>
    <td>४.</td>
    <td>मा.संचालक </td>
    <td>समाजकल्याण, विमुक्त जाती, भटक्या जमाती, इमाव व विमाप्र संचालनालय, महाराष्ट्र राज्य पुणे.</td>
  </tr>
  <tr>
    <td>५.</td>
    <td>मा.व्यवस्थापकीय संचालक </td>
    <td>महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ,प्रशासकीय भवन, ४ था मजला, आर.चेंबुरकर मार्ग, चेंबुर, मुंबई-४०० ०७१.</td>
  </tr>
  <tr>
    <td>६.</td>
    <td>मा.व्यवस्थापकीय संचालक </td>
    <td>महाराष्ट्र राज्य सहकारी बँक, ९ , महाराष्ट्र चेंबर्स ऑफ कॉमर्स लेन, फोर्ट, मुंबई-४०० ००१.</td>
  </tr>
  <tr>
    <td>७.</td>
    <td>मा.सहकार आयुक्त व निबंधक </td>
    <td>नवीन मध्यवर्ती इमारत,२ रा मजला, सेंट्रल बिल्डींग, महाराष्ट्र राज्य, पुणे-१.</td>
  </tr>
</tbody></table>

<p>टीप :- महाराष्ट्र शासन, समाजकल्याण, सांस्कृतिक कार्य व क्रीडा विभाग, यांच्या शासन निर्णय क्र. इमाव १०९६/ प्र.क्र.३९५ / विघयो-२, दि.२५.०९..१९९८ नुसार वरील ७ (सात) शासकीय संचालकांव्यातिरिक्त इतर ८ (आठ) सदस्य हे अशासकीय सदस्य असतात व त्यांची नियुक्ती शासन स्तरावरून करण्यात येते.</p>


        </div>

    <div class="text-box">
        <h2>शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ</h2>
        <h3>(महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळाची उपकंपनी)</h3>
        <p>महाराष्ट्र शासन, सामाजिक न्याय व विशेष सहाय्य विभाग, यांच्या शासन निर्णय क्र. कुविम २००६/ विघयो-२, दि.२६.०३.२०१० नुसार संचालकमंडळातील सदस्यांची यादी</p>
        <table width="100%" border="1" cellspacing="0" cellpadding="0" class="about-table">
              <tbody><tr>
                <td>१.</td>
                <td>शासन नियुक्त पदाधिकारी</td>
                <td>अध्यक्ष</td>
              </tr>
              <tr>
                <td>२.</td>
                <td>उपसचिव, सामाजिक न्याय </td>
                <td>संचालक</td>
              </tr>
              <tr>
                <td>३.</td>
                <td>संचालक, विजाभज,इमाव व विमाप्र,महाराष्ट्र राज्य,पुणे</td>
                <td>संचालक</td>
              </tr>
              <tr>
                <td>४.</td>
                <td>निबंधक सहकारी संस्था प्रतिनिधी </td>
                <td>संचालक</td>
              </tr>
              <tr>
                <td>५.</td>
                <td>व्यवस्थापकीय संचालक,राष्ट्रीय मागासवर्ग वित्त आणि विकास महामंडळ, नवी दिल्ली </td>
                <td> संचालक</td>
              </tr>
              <tr>
                <td>६.	</td>
                <td>व्यवस्थापकीय संचालक, महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ, मुंबई </td>
                <td>व्यवस्थापकीय संचालक</td>
              </tr>
              <tr>
                <td>७.</td>
                <td>अशासकीय सदस्य (दोन)</td>
                <td>संचालक</td>
              </tr>
            </tbody></table>
    </div>

    <div class="text-box">
        <h2>महामंडळाची प्रशासकीय संरचना</h2>
        <ul>
            <li><p>महामंडळाचे प्रशासकीय नियंत्रण शासनाच्या सामाजिक न्याय विभागाकडे आहे. महामंडळाच्या कार्यनियमावलीनुसार मा. अध्यक्ष व संचालक मंडळाची नियुक्ती शासनातर्फे केली जाते. तसेच महामंडळाच्या व्यवस्थापकीय संचालक यांची नियुक्तीही शासनातर्फे करण्यात येते. </p></li>
            <li><p>नोंदणीकृत मुख्यालय प्रशासकीय भवन, ४ था मजला, रामकृष्ण चेंबूरकर मार्ग, चेंबूर, मुंबई - ४०० ०७१ येथे आहे. शासन निर्णय दि. ३०.०३.१९९९ अन्वये महामंडळाच्या मुख्यालयासाठी ३९ पदे तसेच जिल्हा कार्यालयासाठी १०५ पदे अशी मिळून एकूण १४४ पदे मंजूर आहेत. सदर एकूण मंजूर पदांपैकी ७८ पदे भरलेली असून एकूण ६६ पदे रिक्त आहेत. 
</p></li>
            <li><p>दिनांक ०१.०४.२००४ पासून सर्व जिल्ह्यांमध्ये महामंडळाची स्वतंत्र कार्यालये कार्यान्वित झालेली आहेत. महामंडळाची स्वत:ची वेबसाईट असून, सदर वेबसाईटवर महामंडळाच्या स्थापनेपासूनची सर्व माहिती तसेच महामंडळ राबवित असलेल्या सर्व योजनांची माहिती व कर्ज मागणी अर्जाचे नमुने उपलब्ध आहेत. वेबसाईटवर लाभार्थींची यादी वेळोवेळी अद्यायावत करण्यात येते. </p></li>
            <li><p>महामंडळाने प्रायोगिक तत्वावर नाशिक येथे क्षेत्रीय कार्यालय सुरु केले आहे. सदर कार्यालयाच्या अंतर्गत नाशिक, अमरावती व नागपूर या ३ महसूल विभागातील जिल्ह्यांचा समावेश करण्यात आलेला आहे.</p></li>
        </ul>

        <h3>मुख्यालय व जिल्हा कार्यालयातील अधिकारी / कर्मचारी वर्गाचा तपशील</h3>


        <table width="100%" border="1" cellspacing="0" cellpadding="0" class="about-table">
            <tbody><tr>
                <td><h4>अ.क्र.</h4></td>
                <td><h4>पदनाम</h4></td>
                <td><h4>मंजूर पदे</h4></td>
                <td><h4>भरलेली पदे</h4></td>
                <td><h4>रिक्त पदे</h4></td>
            </tr>
            <tr>
            <td>अ.</td>
            <td>मुख्यालय</td>
            <td></td>
            <td></td>
            <td></td>
            </tr>
            <tr>
                <td>१.</td>
                <td><h4>व्यवस्थापकीय संचालक</h4>वेतनश्रेणी रु. १५,६०० - ३९,१०० – ( ग्रेड पे रु. ७,६०० )</td>
                <td>१</td>
                <td>१</td>
                <td>०</td>
            </tr>
            <tr>
                <td>२.</td>
                <td><h4>महाव्यवस्थापक</h4>वेतनश्रेणी रु. १५,६०० - ३९,१०० – ( ग्रेड पे रु. ६,६०० )</td>
                <td>१</td>
                <td>१</td>
                <td>०</td>
            </tr>
            <tr>
                <td>३.</td>
                <td><h4>उपमहाव्यवस्थापक</h4>वेतनश्रेणी रु. १५,६०० - ३९,१०० – ( ग्रेड पे रु. ६,६०० )</td>
                <td>२</td>
                <td>२</td>
                <td>०</td>
            </tr>
            <tr>
                <td>४.</td>
                <td><h4>लेखाधिकारी</h4>वेतनश्रेणी रु. ९,३०० - ३४,८०० – ( ग्रेड पे रु. ५,४०० )</td>
                <td>१</td>
                <td>०</td>
                <td>१</td>
            </tr>
            <tr>
                <td>५.</td>
                <td><h4>मा. अध्यक्षांचे खाजगी सचिव</h4>वेतनश्रेणी रु. ९,३०० - ३४,८०० – ( ग्रेड पे रु. ४,६०० )</td>
                <td>१</td>
                <td>१</td>
                <td>०</td>
            </tr>
            <tr>
                <td>६.</td>
                <td><h4>स्वीय सहाय्यक</h4>वेतनश्रेणी रु. ९,३०० - ३४,८०० – ( ग्रेड पे रु. ४,४०० )</td>
                <td>१</td>
                <td>०</td>
                <td>१</td>
            </tr>
            <tr>
                <td>७.</td>
                <td><h4>सहाय्यक महाव्यवस्थापक </h4>वेतनश्रेणी रु. ९,३०० - ३४,८०० – ( ग्रेड पे रु. ४,४०० )</td>
                <td>४</td>
                <td>२</td>
                <td>२</td>
            </tr>
           
            <tr>
                <td>८.</td>
                <td><h4>उच्चश्रेणी लघुलेखिका</h4>वेतनश्रेणी रु. ९.३०० - ३४,८०० – ( ग्रेड पे रु. ४,४०० )</td>
                <td>२</td>
                <td>२</td>
                <td>०</td>
            </tr>
            <tr>
                <td>९.</td>
                <td><h4>लघुटंकलेखक</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. २,४०० )</td>
                <td>२</td>
                <td>०</td>
                <td>२</td>
            </tr>
            <tr>
                <td>१०.</td>
                <td><h4>लेखापाल</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. २,४०० )</td>
                <td>४</td>
                <td>१</td>
                <td>३</td>
            </tr>
           
            <tr>
                <td>११.</td>
                <td><h4>लिपिक</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. १,९०० )</td>
                <td>८</td>
                <td>०</td>
                <td>८</td>
            </tr>
            <tr>
                <td>१२</td>
                <td><h4>वाहनचालक</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. १,९०० )</td>
                <td>३</td>
                <td>१</td>
                <td>२</td>
            </tr>
            <tr>
                <td>१३.</td>
                <td><h4>शिपाई</h4>वेतनश्रेणी रु. ४,४०० - ७,४४० – ( ग्रेड पे रु. १,३०० )</td>
                <td>९</td>
                <td>१</td>
                <td>८</td>
            </tr>
            <tr>
                <td colspan="2" style="text-align:right"><h4>एकूण ( अ )</h4></td>
                <td><h4>३९</h4></td>
                <td><h4>१२</h4></td>
                <td><h4>२७</h4></td>
            </tr>
            <tr>
            <td>ब.</td>
            <td>जिल्हा कार्यालय</td>
            <td></td>
            <td></td>
            <td></td>
            </tr>
                 <tr>
                <td>१४.</td>
                <td><h4>जिल्हा व्यवस्थापक</h4>वेतनश्रेणी रु. ९.३०० - ३४,८०० – ( ग्रेड पे रु. ४,४०० )</td>
                <td>३५</td>
                <td>३५</td>
                <td>०</td>
            </tr>
             <tr>
                <td>१५.</td>
                <td><h4>वसुली निरीक्षक</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. २,४०० )</td>
                <td>३५</td>
                <td>१७</td>
                <td>१८</td>
            </tr>
            <tr>
                <td>१६.</td>
                <td><h4>लेखापाल</h4>वेतनश्रेणी रु. ५,२०० - २०,२०० – ( ग्रेड पे रु. २,४०० )</td>
                <td>३५</td>
                <td>१४</td>
                <td>२१</td>
            </tr>
             <tr>
                <td colspan="2" style="text-align:right"><h4>एकूण ( ब ) </h4></td>
                <td><h4>१०५</h4></td>
                <td><h4>६६</h4></td>
                <td><h4>३९</h4></td>
            </tr>
             <tr>
                <td colspan="2" style="text-align:right"><h4>एकूण ( अ + ब ) </h4></td>
                <td><h4>१४४</h4></td>
                <td><h4>७८</h4></td>
                <td><h4>६६</h4></td>
            </tr>
        </tbody></table>
    </div>

      </section>
    </div>
  </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
  components: { PortalNavbar }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Laila:400,500&display=swap&subset=devanagari");

#about-us-section {
  width: 1100px;
  margin: auto;
  margin-top: 45px;
  font-family: "Laila", serif;
  text-align: center;
  overflow:hidden;
}

#about-us-section .text-box {
  margin-bottom: 35px;
}

#about-us-section h2 {
  font-size: 33px;
  color: rgb(236, 86, 36);
  margin-bottom: 20px;
}

#about-us-section p {
  font-family: "Laila", serif;
}

#about-us-section h3{
    font-size: 22px;
    margin-bottom: 10px;
}

#about-us-section ul li {
  margin-bottom: 10px;
}

#about-us-section ul li p {
  text-align: left;
}


#about-us-section .about-table td{
    padding:5px;
    border:2px solid #555;
}

#about-us-section .about-table{
    border:2px solid #555;
    margin-bottom: 10px;
    margin-top:10px;
}


#about-us-section .about-table h4{
    font-size: 19px;
}


/* Responsive styles start here */



@media(max-width: 1199px){
    #about-us-section{
        width: 900px;
    }
}

@media(max-width: 991px){
     #about-us-section{
        width: 700px;
        padding-left: 10px;
        padding-right: 10px;
    }

    #about-us-section h2{
        font-size: 30px;
    }
    #about-us-section h3{
        font-size: 20px;
    }

    #about-us-section .about-table h4{
        font-size: 17px;
    }

    #about-us-section p {
        font-size: 15px;
    }

    #about-us-section .about-table{
        font-size: 15px;
    }
}

@media(max-width: 767px){
     #about-us-section{
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }
    #about-us-section h2{
        font-size: 21px;
    }

    #about-us-section h3{
        font-size: 15px;
    }

    #about-us-section .about-table h4{
        font-size: 14px;
    }

    #about-us-section p{
        font-size: 13px;
    }

    #about-us-section .about-table{
        font-size: 11px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Portal/About.vue